import axios from 'axios'

const service = axios.create({
  baseURL: '/api',  // 使用代理配置
  timeout: 5000
})

// 移除请求拦截器中的 token 逻辑
service.interceptors.request.use(
  config => {
    return config
  },
  error => Promise.reject(error)
)

// 保留响应拦截器的逻辑
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200) {
      return res
    }
    return Promise.reject(new Error(res.msg || '请求失败'))
  },
  error => Promise.reject(error)
)

export default service
